import dayjs from "utils/dayjs-config";

export interface CalHolidaysWeekends {
  holidays?: Array<{ date: string }>;
  weekends?: number[];
}

/**
 * Snaps a date backward off holidays/weekends to the nearest valid working day
 * (max 10 attempts). Pure — takes the project holiday/weekend calendar as input.
 */
export const findPreviousValidDate = (
  startDate: dayjs.Dayjs,
  calHolidaysWeekends?: CalHolidaysWeekends
): dayjs.Dayjs => {
  // An invalid dayjs (e.g. dayjs(null) from a cleared picker) has a NaN day(),
  // so every comparison below is false and the loop just spins to its cap before
  // handing the same invalid date back. Return it straight away — invalid in,
  // invalid out — and let the caller decide.
  if (!startDate.isValid()) return startDate;

  const holidays = calHolidaysWeekends?.holidays;
  const weekends = calHolidaysWeekends?.weekends;
  let currentDate = startDate.clone();

  const isDisabledDate = (date: dayjs.Dayjs) => {
    let disableHolidaysResult = false;
    let disableWeekendsResult = false;

    if (holidays) {
      disableHolidaysResult = !!holidays.find((hld: any) =>
        date.isSame(dayjs(hld?.date), "day")
      );
    }

    if (weekends) {
      disableWeekendsResult = weekends.some(
        (wkend: number) => date.day() === wkend
      );
    }

    return disableHolidaysResult || disableWeekendsResult;
  };

  let attempts = 0;
  while (isDisabledDate(currentDate) && attempts < 10) {
    currentDate = currentDate.subtract(1, "day");
    attempts += 1;
  }

  return currentDate;
};
